import React from 'react'
import ReactDOM from 'react-dom'
import { createStore, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import { Provider } from 'react-redux'
import { Router, Route, browserHistory } from 'react-router'
import { syncHistoryWithStore, routerMiddleware, push } from 'react-router-redux'
import Thunk from 'redux-thunk'
import AppContainer from './components/AppContainer'
import FormApp from './containers/FormApp'
import rootReducer from './reducers'
import * as serviceWorker from './serviceWorker'
import { PopupContainerList, PopupContainerSettings, PopupContainerQuiz } from './containers/PopupContainer'

const middleware = [Thunk, routerMiddleware(browserHistory)]

//*** Developer mode
const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(...middleware)));

//*** Production mode
//const store = createStore(rootReducer, applyMiddleware(...middleware));

// Create an enhanced history that syncs navigation events with the store
const history = syncHistoryWithStore(browserHistory, store)

ReactDOM.render(
  <Provider store={store}>
    { /* Tell the Router to use our enhanced history */}
    <Router history={history}>
      <Route path="/" component={AppContainer}>
        <Route path="settings" component={PopupContainerList} />
        <Route path="settings/:id" component={props => { props = { ...props, fromEditor: false }; return <PopupContainerSettings {...props} /> } } />
        <Route path="settings/:id/:tab" component={props => { props = { ...props, fromEditor: false }; return <PopupContainerSettings {...props} /> }} />
        {/* adding those 2 paths so we can have a different url for "from editor" editing*/}
        <Route path="settingsfe/:id" component={props => { props = { ...props, fromEditor: true }; return <PopupContainerSettings {...props} /> }} />
        <Route path="settingsfe/:id/:tab" component={props => { props = { ...props, fromEditor: true }; return <PopupContainerSettings {...props} /> }} />
        <Route path="quizsubmission/:quizid" component={props => { props = { ...props, fromEditor: true }; return <PopupContainerQuiz {...props} /> }} />
        <Route path=":id/:pid" component={FormApp} />
      </Route>
    </Router>
  </Provider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
